import React, {useEffect, useRef, useState} from 'react'
import {FiUser} from 'react-icons/fi'
import {fetchSignedUrl, uploadImageToS3} from '../helper/helperFunction'
import {toast} from 'react-toastify'

interface Props {
  imageUrl: string | null
  onChange: (url: string) => void
}

const ImagePickerUploader: React.FC<Props> = ({imageUrl, onChange}) => {
  const notifyError = (msg: string) => toast.error(msg)

  const inputRef = useRef<HTMLInputElement>(null)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isUploading, setIsUploading] = useState(false)
  const [signedUrl, setSignedUrl] = useState<string | null>(null)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleIconClick = () => inputRef.current?.click()

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp']
    if (!allowedTypes.includes(file.type)) {
      notifyError('Unsupported file type. Only JPG, PNG, or WEBP allowed.')
      return
    }

    setIsUploading(true)

    try {
      const uploadedUrl = await uploadImageToS3(file)
      onChange(uploadedUrl) // this should be the S3 key, like "public/images/..."
    } catch (err: any) {
      notifyError('Image upload failed.')
    } finally {
      setIsUploading(false)
    }
  }

  // fetch presigned URL
  const handleFetchSignedURL = async () => {
    try {
      const preSignedURL = await fetchSignedUrl(imageUrl)
      setSignedUrl(preSignedURL)
    } catch (err: any) {
      notifyError('Image upload failed.')
      setSignedUrl(null)
    } finally {
      setIsUploading(false)
    }
  }

  // Fetch signed URL whenever `imageUrl` changes
  useEffect(() => {
    handleFetchSignedURL()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageUrl])

  return (
    <div className='d-flex justify-content-center'>
      <div className='position-relative' style={{width: 90, height: 90}}>
        {signedUrl ? (
          <img
            src={signedUrl}
            alt='Profile'
            className='rounded-circle object-fit-cover w-100 h-100'
          />
        ) : (
          <div className='bg-light rounded-circle d-flex align-items-center justify-content-center w-100 h-100'>
            <FiUser className='fs-1 text-gray-600' />
          </div>
        )}

        {/* <button
          type='button'
          disabled={isUploading || process.env.REACT_APP_ENV == 'production'}
          onClick={handleIconClick}
          className='btn btn-sm btn-light rounded-circle position-absolute bottom-0 end-0 border shadow-sm'
          style={{padding: 6}}
        >
          {isUploading ? (
            <span className='spinner-border spinner-border-sm text-primary' />
          ) : (
            <FiCamera className='text-primary fs-6' />
          )}
        </button> */}

        <input
          type='file'
          accept='image/jpeg, image/png, image/webp'
          className='d-none'
          ref={inputRef}
          onChange={handleFileChange}
        />
      </div>
    </div>
  )
}

export default ImagePickerUploader
